// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2Ixgi","inputWrap":"Table_inputWrap__3waxh","col":"Table_col__hrnIw","bmiTooltip":"Table_bmiTooltip__ZsE6Q"};